import styled from "styled-components";
import { InputNumber } from "antd";

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const SubCard = styled.div`
  background: ${({ theme }) => theme.settings.whiteColor};
  border: 1px solid #edeef3;
  border-radius: 10px;
  overflow: hidden;
`;

export const SubCardHeader = styled.div`
  background: linear-gradient(to right, #f3f4f6, #ffffff);
  padding: 12px 22px;
  border-bottom: 1px solid #f0f0f0;
`;

export const SubCardTitle = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #1f2430;
  font-family: ${({ theme }) => theme.fonts.inter};
`;

export const SubCardBody = styled.div`
  padding: 16px 22px;

  .fieldLabel {
    font-size: 12px;
    font-weight: 500;
    color: #1f2430;
    margin: 0 0 8px 0;
    padding: 0;
    display: block;
    font-family: ${({ theme }) => theme.fonts.inter};
    line-height: 1.4;
  }

  .audienceNumber {
    margin: 0 !important;
    width: 100%;
    border-radius: 10px !important;
    border: 1px solid rgba(31, 36, 48, 0.1) !important;

    .ant-input-number-handler-wrap {
      display: none;
    }
  }

  .audienceInput {
    min-height: 42px;
    height: 42px;
    border-radius: 10px !important;
    border: 1px solid rgba(31, 36, 48, 0.1) !important;
    background: ${({ theme }) => theme.settings.whiteColor} !important;
    padding: 0 16px;
    font-weight: 400;
    color: #1f2430;
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.inter};
    margin: 0 !important;

    &::placeholder {
      color: rgba(10, 27, 57, 0.4);
    }

    &:focus {
      border-color: ${({ theme }) => theme.settings.primary} !important;
      box-shadow: none !important;
    }
  }
`;

export const AgeRangeHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;

  .fieldLabel {
    font-size: 12px;
    font-weight: 500;
    color: #1f2430;
    font-family: ${({ theme }) => theme.fonts.inter};
  }

  .ageValue {
    font-size: 12px;
    font-weight: 600;
    color: #3d2969;
    font-family: ${({ theme }) => theme.fonts.inter};
    background: rgba(61, 41, 105, 0.1);
    padding: 2px 8px;
    border-radius: 4px;
  }
`;

export const AgeSliderWrapper = styled.div`
  padding: 4px 0 0 0;
  position: relative;

  .ant-slider {
    margin: 0;
    height: 14px;
  }

  .ant-slider-rail {
    height: 6px;
    background: #f0f0f0;
    border-radius: 100px;
    top: 4px;
  }

  .ant-slider-track {
    height: 6px;
    background: linear-gradient(90deg, #a8a0b8 0%, #3d2969 100%);
    border-radius: 100px;
    top: 4px;
  }

  .ant-slider-handle {
    width: 14px !important;
    height: 14px !important;
    border: 2px solid #3d2969 !important;
    background: #3d2969 !important;
    border-radius: 50% !important;
    box-shadow: none !important;
    margin-top: 0 !important;
    top: 0 !important;
    transform: translateX(-50%) !important;

    &::before,
    &::after {
      display: none !important;
    }

    &:hover,
    &:focus,
    &:active {
      background: #3d2969 !important;
      border-color: #3d2969 !important;
      box-shadow: 0 0 0 5px rgba(61, 41, 105, 0.12) !important;
    }
  }

  .ant-slider-mark {
    display: none;
  }

  .ant-slider-dot {
    display: none;
  }

  .ant-tooltip {
    .ant-tooltip-inner {
      background: #1f2430;
      font-size: 12px;
      font-weight: 500;
      min-height: 24px;
      padding: 4px 8px;
      border-radius: 4px;
    }
    .ant-tooltip-arrow::before {
      background: #1f2430;
    }
  }
`;

export const TickMarksRuler = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 8px;
  padding: 0 5px;
`;

export const TickMark = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;

  &::before {
    content: '';
    width: 1px;
    height: ${({ $isMajor }) => ($isMajor ? '8px' : '5px')};
    background: ${({ $isMajor }) => ($isMajor ? 'rgba(31, 36, 48, 0.25)' : 'rgba(31, 36, 48, 0.12)')};
  }

  .label {
    font-size: 10px;
    font-weight: 500;
    color: rgba(31, 36, 48, 0.6);
    font-family: ${({ theme }) => theme.fonts.inter};
    margin-top: 2px;
    white-space: nowrap;
  }
`;

export const InlineRadioGroup = styled.div`
  display: flex;
  align-items: center;
  min-height: 42px;
  padding: 0 20px;
  border: 1px solid rgba(31, 36, 48, 0.1);
  border-radius: 10px;
  background: ${({ theme }) => theme.settings.whiteColor};

  .ant-radio-group {
    display: flex;
    align-items: center;
    gap: 32px;
  }

  .ant-radio-wrapper {
    font-size: 14px;
    font-family: ${({ theme }) => theme.fonts.inter};
    color: #1f2430;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;

    .ant-radio {
      top: 0;
    }

    .ant-radio-inner {
      width: 14px;
      height: 14px;
      border: 1px solid rgba(31, 36, 48, 0.2);
    }

    .ant-radio-checked .ant-radio-inner {
      border-color: #3d2969 !important;
      background-color: #3d2969 !important;
    }

    .ant-radio:hover .ant-radio-inner {
      border-color: #3d2969 !important;
    }

    .ant-radio-inner::after {
      background-color: white !important;
      width: 6px;
      height: 6px;
      margin-block-start: -3px;
      margin-inline-start: -3px;
    }
  }
`;

// Income input wrapper with $ prefix (similar to Age field but with spinners)
export const IncomeInputWrapper = styled.div`
  display: flex;
  border: 1px solid rgba(31, 36, 48, 0.1);
  border-radius: 10px;
  height: 42px;
  overflow: hidden;
  background: white;
  flex: 1;

  &:hover {
    border-color: rgba(31, 36, 48, 0.2);
  }

  &:focus-within {
    border-color: #3d2969;
  }

  .income-prefix {
    background: #eae7ee;
    border-right: 1px solid rgba(31, 36, 48, 0.1);
    padding: 0 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: ${({ theme }) => theme.fonts.inter};
    font-size: 14px;
    font-weight: 500;
    color: #485066;
    flex-shrink: 0;
  }

  .ant-input-number {
    flex: 1;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    height: 40px !important;

    &:hover,
    &:focus,
    &.ant-input-number-focused {
      border: none !important;
      box-shadow: none !important;
    }

    .ant-input-number-input {
      height: 40px;
      border: none;
      box-shadow: none;
      font-family: ${({ theme }) => theme.fonts.inter};
      font-size: 14px;
      color: #1f2430;
    }

    .ant-input-number-handler-wrap {
      display: none;
    }
  }
`;
